import { render } from "./ModalBody.vue?vue&type=template&id=78cdad18&ts=true"
import script from "./ModalBody.vue?vue&type=script&lang=ts"
export * from "./ModalBody.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__